import React, { FC } from 'react';
import Typography from '@mui/material/Typography';

interface MigrationSourceValueProps {
  value: string | null | undefined;
}

export const MigrationSourceValue: FC<MigrationSourceValueProps> = ({ value }) => (
  <Typography
    variant="body2"
    color={value ? 'textPrimary' : 'textSecondary'}
    style={{ whiteSpace: 'pre-wrap' }}
  >
    {value || 'Not set'}
  </Typography>
);
